import * as React from "react";
import styled from "styled-components";
import { Field } from "formik";
import isEqual from "lodash/isEqual";
import uniq from "lodash/uniq";
import { Trans, useTranslation } from "react-i18next";
import ParameterInput from "enterprise/parameters/components/ParameterInput";
import Input from "components/bootstrap/Input";
import newParameterState from "enterprise/parameters/logic/newParameterState";
import { Alert } from "components/bootstrap";
const ParameterInputRow = styled.div`
  &:first-child {
    margin-top: 10px;
  }

  .form-group {
    display: flex;
    align-items: baseline;
  }
`;
const Parameter = ({ parameter, searchId }) => /* @__PURE__ */ React.createElement(Field, { key: `parameter-field-${parameter.name}`, name: `parameterValues.${parameter.name}` }, ({ field: { name, value, onBlur }, form: { setFieldValue }, meta: { error } }) => /* @__PURE__ */ React.createElement(Input, { id: `parameter-${name}`, error }, /* @__PURE__ */ React.createElement(ParameterInputRow, { key: name }, /* @__PURE__ */ React.createElement(
  ParameterInput,
  {
    parameter,
    searchId,
    value,
    onBlur,
    onChange: (_field, newValue, triggerValidation) => setFieldValue(name, newValue, triggerValidation)
  }
))));
const ReportParameters = ({ parameters, parameterSearchIds }) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dd", null, Object.values(parameters).map((paramDefinitions) => {
    if (paramDefinitions.length > 1 && !paramDefinitions.every((definition) => isEqual(definition, paramDefinitions[0]))) {
      const genericParam = newParameterState(paramDefinitions[0].name);
      const parameterTitles = uniq(paramDefinitions.map(({ title }) => title));
      return /* @__PURE__ */ React.createElement(React.Fragment, { key: paramDefinitions[0].name }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, /* @__PURE__ */ React.createElement(
        Trans,
        {
          t,
          i18nKey: "report_parameters.different_parameters",
          values: { name: paramDefinitions[0].name, titles: parameterTitles.join(", ") },
          components: { b: /* @__PURE__ */ React.createElement("b", null) }
        }
      )), /* @__PURE__ */ React.createElement(Parameter, { parameter: genericParam, searchId: void 0 }));
    }
    return /* @__PURE__ */ React.createElement(
      Parameter,
      {
        parameter: paramDefinitions[0],
        key: paramDefinitions[0].name,
        searchId: parameterSearchIds[paramDefinitions[0].name]
      }
    );
  })));
};
export default ReportParameters;
